export default __webpack_public_path__ + "static/media/numberfiftheen.a42f0e81.png";